import axios from 'axios'

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/`;
// const BASE_URL = "https://bl-practice-attendance-prod-187791816934.asia-south1.run.app/api/v1/"

export const getData = (url, headers) => {
    return axios.get(`${BASE_URL}${url}`, headers)
}

export const postData = (url, data, header) => {
    return axios.post(`${BASE_URL}${url}`, data, header)
}

export const patchData = (url, data, header) => {
    return axios.patch(`${BASE_URL}${url}`, data, header)
}

export const deleteData = (url, header) => {
    return axios.delete(`${BASE_URL}${url}`, header)
}

export const putData = (url, data, header) => {
    return axios.put(`${BASE_URL}${url}`, data, header)
}



